import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getQuestionsTypes = async () => {
  return await request.get(
    '/Question/types',
    {},
    'При загрузке типов вопросов произошла ошибка',
    []
  );
};

const useQuestionsTypes = (options) =>
  useQuery(questionsQueryKeys.types(), getQuestionsTypes, options);

export default useQuestionsTypes;
